import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import React from 'react';
import './MaterialMultiSelect.css';

interface Option {
  value: string | number;
  label: string;
}

interface MaterialMultiSelectProps {
  id?: string;
  label: string;
  value: (string | number)[];
  options: Option[];
  onChange: (values: (string | number)[]) => void;
  className?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  variant?: 'outlined' | 'filled' | 'standard';
  size?: 'small' | 'medium';
}

const MaterialMultiSelect: React.FC<MaterialMultiSelectProps> = ({
  id,
  label,
  value,
  options,
  onChange,
  className = '',
  fullWidth = true,
  disabled = false,
  variant = 'outlined',
  size = 'small',
}) => {
  const handleChange = (event: SelectChangeEvent<(string | number)[]>) => {
    const newValue = event.target.value;
    onChange(typeof newValue === 'string' ? newValue.split(',') : newValue);
  };

  return (
    <FormControl
      variant={variant}
      fullWidth={fullWidth}
      size={size}
      className={`material-multiselect ${className}`}
      disabled={disabled}
    >
      <InputLabel
        id={`${id || label.toLowerCase().replace(/\s+/g, '-')}-label`}
      >
        {label}
      </InputLabel>
      <Select
        labelId={`${id || label.toLowerCase().replace(/\s+/g, '-')}-label`}
        id={id || label.toLowerCase().replace(/\s+/g, '-')}
        multiple
        value={value}
        label={label}
        onChange={handleChange}
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {(selected as (string | number)[]).map((val) => {
              const option = options.find((opt) => opt.value === val);
              return (
                <Chip
                  key={val}
                  label={option?.label || val}
                  size="small"
                  color="primary"
                  variant="outlined"
                />
              );
            })}
          </Box>
        )}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 300,
            },
          },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MaterialMultiSelect;
